module.exports = __webpack_public_path__ + "static/media/luchador.a67324cd.svg";